module.exports = __webpack_public_path__ + "static/media/3 09 Tulleord Vor er riktig.d1ac50fa.mp3";